import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal/LegalPage";
import { CookiePolicy } from "@/components/legal/LegalModal";

export const Route = createFileRoute("/es/cookies")({
  head: () => ({
    meta: [
      { title: "Política de cookies — Sellavo" },
      { name: "description", content: "Qué cookies utiliza Sellavo y cómo puedes controlarlas." },
      { property: "og:title", content: "Política de cookies — Sellavo" },
      { property: "og:description", content: "Qué cookies utiliza Sellavo y cómo puedes controlarlas." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/cookies" }],
  }),
  component: () => <LegalPage title="Política de cookies" intro="Qué cookies utiliza Sellavo y cómo puedes controlarlas."><CookiePolicy /></LegalPage>,
});
